import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);
export const PopupActionBar = ({ children, lonely, column }) => (
  <div className={cx('action-bar', { lonely, column })}>
    {children}
  </div>
);

PopupActionBar.propTypes = {
  children: PropTypes.func,
  lonely: PropTypes.bool,
  column: PropTypes.bool,
};
